// ------------BurgerMenuModule------------
const BurgerMenuModule = {
  init() {
    const burgerMenu = document.getElementById('burgerMenu');
    const headerMenu = document.getElementById('headerMenu');
    const overlay = document.getElementById('drawerOverlay');

    if (!burgerMenu || !headerMenu) return;

    // Открытие/закрытие по бургеру
    burgerMenu.addEventListener('click', function () {
      burgerMenu.classList.toggle('burger__active');
      headerMenu.classList.toggle('burger__active');
      if (overlay) overlay.classList.toggle('burger__active');

      const isExpanded = burgerMenu.classList.contains('burger__active');
      burgerMenu.setAttribute('aria-expanded', isExpanded);

      // Блокируем скролл страницы когда меню открыто
      document.body.style.overflow = isExpanded ? 'hidden' : '';
    });

    // Закрытие по клику на пункт меню
    const menuLinks = document.querySelectorAll('.drawer__link');
    menuLinks.forEach(link => {
      link.addEventListener('click', function () {
        BurgerMenuModule.close();
      });
    });

    // Закрытие по клику на оверлей
    if (overlay) {
      overlay.addEventListener('click', function () {
        BurgerMenuModule.close();
      });
    }
  },

  close() {
    const burgerMenu = document.getElementById('burgerMenu');
    const headerMenu = document.getElementById('headerMenu');
    const overlay = document.getElementById('drawerOverlay');

    if (burgerMenu) burgerMenu.classList.remove('burger__active');
    if (headerMenu) headerMenu.classList.remove('burger__active');
    if (overlay) overlay.classList.remove('burger__active');
    if (burgerMenu) burgerMenu.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
  }
};
// ------------END------------

// ------------SliderModule (Vanilla JS: Splide + GLightbox) ------------
const SliderModule = {
  init() {
    // 1. Инициализация Слайдера (замена Slick)
    const sliderElement = document.querySelector('.splide'); // В HTML нужно добавить класс splide и обертку
    if (sliderElement) {
      new Splide('.splide', {
        type: 'loop',         // Бесконечный цикл
        focus: 'center',       // Аналог centerMode
        autoWidth: true,       // Аналог variableWidth
        gap: '20px',           // Расстояние между слайдами
        autoplay: true,
        interval: 3000,
        arrows: false,
        pagination: false,
        perPage: 3,
        breakpoints: {
          768: {
            perPage: 3,
            gap: '10px',
          },
          480: {
            perPage: 1,
            gap: '5px',
            focus: 'center',
          },
        },
      }).mount();
    }

    // 2. Инициализация Лайтбокса (замена Lightbox2)
    // Больше не нужно настраивать опции отдельно, все делается одной строкой
    if (typeof GLightbox !== 'undefined') {
      const lightbox = GLightbox({
        selector: '.glightbox',
        loop: true,                 // ВКЛЮЧАЕТ ПРОЛИСТЫВАНИЕ ПО КРУГУ
        touchNavigation: true,      // Свайпы на мобильных
        touchFollowMouse: true,     // Картинка "идет" за пальцем
        dragNavigation: true,       // Листание мышкой на десктопе
        keyboardNavigation: true,   // Стрелочки на клавиатуре
        openEffect: 'zoom',
        closeEffect: 'zoom'
      });
    }
  }
};
// ------------END ------------

// ------------ProductModule: Подсчет общей суммы для каждого товара-----
const ProductModule = {
  init() {
    document.querySelectorAll('.products__card-section').forEach(section => {
      this.initializeProduct(section);
      this.updateTotalAmount(section);
    });
  },

  updateTotalAmount(section) {
    let totalAmount = 0;
    const productOrders = section.querySelectorAll('.products__card-order');

    productOrders.forEach(order => {
      const priceElement = order.querySelector('.product__price');
      const quantityElement = order.querySelector('.products__card-number');

      if (priceElement && quantityElement) {
        // --- ИЗМЕНЕНИЕ ЗДЕСЬ ---
        // Очищаем строку от пробелов и используем parseFloat
        const price = parseFloat(priceElement.textContent.trim());
        const quantity = Number(quantityElement.textContent); // Number() здесь работает нормально для целых чисел

        // Проверяем, что цена и количество являются числами
        if (!isNaN(price) && !isNaN(quantity)) {
          totalAmount += price * quantity;
        }
      }
    });

    // Выводим посчитанную сумму на экран
    const totalAmountElement = section.querySelector('.products__total-amount');
    if (totalAmountElement) {
      totalAmountElement.textContent = totalAmount;
    }
  },

  initializeProduct(section) {
    const productOrders = section.querySelectorAll('.products__card-order');

    productOrders.forEach(order => {
      const plusBtn = order.querySelector('.products__card-btn--plus');
      const minusBtn = order.querySelector('.products__card-btn--minus');
      const numberDisplay = order.querySelector('.products__card-number');

      if (plusBtn && minusBtn && numberDisplay) {
        plusBtn.addEventListener('click', () => {
          let currentQuantity = Number(numberDisplay.textContent);
          currentQuantity += 1;
          numberDisplay.textContent = currentQuantity;
          this.updateTotalAmount(section);
        });

        minusBtn.addEventListener('click', () => {
          let currentQuantity = Number(numberDisplay.textContent);
          if (currentQuantity > 0) {
            currentQuantity -= 1;
            numberDisplay.textContent = currentQuantity;
            this.updateTotalAmount(section);
          }
        });
      }
    });
  }
};
// ------------END------------

// ------------PhoneModule (управление телефоном на checkout)------------
const PhoneModule = {
  init() {
    const phoneInput = document.getElementById('phone');

    // Проверяем, существует ли элемент
    if (!phoneInput) return;

    // Устанавливаем начальное значение
    if (!phoneInput.value) {
      phoneInput.value = '+380';
    }

    phoneInput.addEventListener('input', function (e) {
      let value = e.target.value;

      // Запрещаем удалять +380
      if (!value.startsWith('+380')) {
        value = '+380';
      }

      // Удаляем все символы кроме цифр и +
      value = value.replace(/[^\d+]/g, '');

      // Ограничиваем длину
      if (value.length > 13) {
        value = value.slice(0, 13);
      }

      // Форматируем номер
      if (value.length > 3) {
        let formatted = value.match(/(\+\d{3})(\d{0,2})(\d{0,3})(\d{0,2})(\d{0,2})/);
        value = formatted[1] +
          (formatted[2] ? ' ' + formatted[2] : '') +
          (formatted[3] ? ' ' + formatted[3] : '') +
          (formatted[4] ? ' ' + formatted[4] : '') +
          (formatted[5] ? ' ' + formatted[5] : '');
      }

      this.value = value;
    });

    // Запрещаем удаление +380 при удалении или вырезании
    phoneInput.addEventListener('keydown', function (e) {
      if (e.key === 'Backspace' || e.key === 'Delete') {
        if (this.value.length <= 4) {
          e.preventDefault();
        }
      }
    });
  }
};
// ------------END------------

// ------------CartModule - корзина------------
const CartModule = {
  // Главный инициализатор
  init() {
    this.updateCartCounter();
    this.initProductPage();
    this.initCheckoutPage();
  },

  // Логика кнопки "В корзину"
  initProductPage() {
    const addToCartButton = document.querySelector('.products__card-btn--order');
    if (!addToCartButton) return;

    addToCartButton.addEventListener('click', (e) => {
      // 1. Проверяем сумму
      const totalAmountElement = document.querySelector('.products__total-amount');
      const totalAmount = parseFloat(totalAmountElement.textContent);

      // 2. ЕСЛИ СУММА 0 — ЗАПУСКАЕМ АНИМАЦИЮ
      if (totalAmount === 0) {
        // ИСПОЛЬЗУЕМ CartModule ВМЕСТО this ДЛЯ НАДЕЖНОСТИ
        CartModule.triggerZeroAmountAnimation(addToCartButton, totalAmountElement);
        return;
      }

      // 3. Если сумма > 0, сохраняем (также через CartModule для надежности)
      CartModule.saveToCart();
    });
  },

  // --- ФУНКЦИЯ: Анимация ошибки ---
  triggerZeroAmountAnimation(button, amountElement) {

    // 2. Красим кнопку и меняем текст
    button.classList.add('btn-error');
    const span = button.querySelector('span');
    const originalText = span.textContent;

    // Текст ошибки (можно оставить хардкод или брать из ui.json)
    const errorText = document.documentElement.lang === 'uk' ? 'Оберіть товар!' : 'Выберите товар!';
    span.textContent = errorText;

    // 3. Красим цифру 0
    amountElement.classList.add('amount-error');

    // 4. Через 2 секунды сбрасываем всё назад
    setTimeout(() => {
      button.classList.remove('shake-animation');
      button.classList.remove('btn-error');
      span.textContent = originalText;
      amountElement.classList.remove('amount-error');
    }, 2000);
  },

  // Страница корзины (Checkout)
  initCheckoutPage() {
    const productsList = document.querySelector('.selected-products__list');
    if (!productsList) return;

    this.displayCartItems();
    this.initRemoveButtons();
  },

  // Обновление счетчика в шапке
  updateCartCounter() {
    const cartItems = JSON.parse(localStorage.getItem('cart')) || [];
    const counter = document.querySelector('.header__cart-amount');
    if (counter) {
      const totalItems = cartItems.reduce((sum, item) => sum + item.quantity, 0);
      counter.textContent = totalItems;
    }
  },

  // Сохранение в корзину
  saveToCart() {
    const productOrders = document.querySelectorAll('.products__card-order');
    let cartItems = JSON.parse(localStorage.getItem('cart')) || [];

    let itemsForAnalytics = [];
    let totalValueAdded = 0;

    productOrders.forEach(order => {
      const volumeElement = order.querySelector('.product__packaging');
      const priceElement = order.querySelector('.product__price');
      const quantityElement = order.querySelector('.products__card-number');

      if (volumeElement && priceElement && quantityElement) {
        const quantity = parseInt(quantityElement.textContent);

        // Берем чистые данные (SKU и Name)
        const cleanSku = order.dataset.sku || 'no-sku';
        const cleanName = order.dataset.name || 'Unknown Product';

        const price = parseFloat(priceElement.textContent.trim());
        const volume = volumeElement.textContent.trim();

        if (quantity > 0) {
          const itemTotal = quantity * price;

          // Аналитика
          itemsForAnalytics.push({
            item_id: cleanSku,
            item_name: cleanName,
            price: price,
            quantity: quantity
          });

          totalValueAdded += itemTotal;

          // Логика добавления (или обновления кол-ва)
          const existingItemIndex = cartItems.findIndex(item => item.sku === cleanSku);

          if (existingItemIndex !== -1) {
            cartItems[existingItemIndex].quantity += quantity;
            cartItems[existingItemIndex].total += itemTotal;
          } else {
            cartItems.push({
              sku: cleanSku,
              title: cleanName,
              volume: volume,
              price: price,
              quantity: quantity,
              total: itemTotal
            });
          }
        }
      }
    });

    if (itemsForAnalytics.length > 0) {
      AnalyticsModule.sendAddToCartData(itemsForAnalytics, totalValueAdded);
    }

    localStorage.setItem('cart', JSON.stringify(cartItems));
    this.updateCartCounter();
  },

  // Удаление счетчиков (если нужно)
  resetProductCounters() {
    const productOrders = document.querySelectorAll('.products__card-order');
    productOrders.forEach(order => {
      const quantityElement = order.querySelector('.products__card-number');
      if (quantityElement) quantityElement.textContent = '0';
    });
    const totalAmountElement = document.querySelector('.products__total-amount');
    if (totalAmountElement) totalAmountElement.textContent = '0';
  },

  // Удаление товара (кнопка в корзине)
  initRemoveButtons() {
    const productsList = document.querySelector('.selected-products__list');
    if (productsList) {
      productsList.addEventListener('click', (event) => {
        if (event.target.classList.contains('selected-products__item-remove')) {
          const index = event.target.getAttribute('data-index');
          this.removeFromCart(index);
        }
      });
    }
  },

  removeFromCart(index) {
    let cartItems = JSON.parse(localStorage.getItem('cart')) || [];
    if (index >= 0 && index < cartItems.length) {
      cartItems.splice(index, 1);
      localStorage.setItem('cart', JSON.stringify(cartItems));
      this.updateCartCounter();
      this.displayCartItems();
    }
  },

  // Отображение товаров в корзине
  displayCartItems() {
    setTimeout(() => {
      const cartItems = JSON.parse(localStorage.getItem('cart')) || [];
      const productsList = document.querySelector('.selected-products__list');
      let totalSum = 0;

      if (!productsList) return;

      productsList.innerHTML = '';

      if (cartItems.length > 0) {
        cartItems.forEach((item, index) => {
          const productElement = document.createElement('div');
          productElement.className = 'selected-products__item';
          productElement.innerHTML = `
          <div class="selected-products__item-info">
            <span class="selected-products__item-name">${item.title}</span>
            <span class="selected-products__item-volume">${item.volume}</span>
          </div>
          <div class="selected-products__item-numbers">
            <span class="selected-products__item-quantity">Количество: ${item.quantity}</span>
            <span class="selected-products__item-price">${item.total} грн</span>
            <button class="selected-products__item-remove" data-index="${index}">Удалить</button>
          </div>
        `;
          productsList.appendChild(productElement);
          totalSum += item.total;
        });
      }

      const totalAmountElement = document.querySelector('.selected-products__total-amount');
      if (totalAmountElement) {
        totalAmountElement.textContent = totalSum;
      }
    }, 100);
  },
};
// ------------END------------

// ------------Обработка формы и отправка в Telegram + NovaPay------------
const FormModule = {

  // Флаг блокировки повторной отправки
  isSubmitting: false,

  init() {
    const form = document.getElementById('checkout-form');

    // ПРОВЕРКА: Вешаем слушатель только если его еще нет (защита от двойной инициализации)
    if (form && !form.dataset.initialized) {
      form.addEventListener('submit', this.handleFormSubmit.bind(this));
      form.dataset.initialized = 'true'; 
    }
  },

  async handleFormSubmit(e) {
    e.preventDefault();

    // ЗАМОК: Если форма уже отправляется — игнорируем нажатия
    if (this.isSubmitting) return;
    this.isSubmitting = true;

    const form = e.target;
    const submitButton = form.querySelector('button[type="submit"]');

    // Визуально блокируем кнопку
    if (submitButton) {
      submitButton.disabled = true;
      submitButton.style.opacity = '0.5';
      submitButton.innerText = 'Відправка...';
    }

    // Получаем корзину
    const cartItems = JSON.parse(localStorage.getItem('cart')) || [];

    if (cartItems.length === 0) {
      alert('Будь ласка, додайте товари в кошик...');
      this.isSubmitting = false;
      if (submitButton) { submitButton.disabled = false; submitButton.style.opacity = '1'; submitButton.innerText = 'Замовити'; }
      return;
    }

    // --- ПРОВЕРКА НОМЕРА ---
    const phoneInput = form.querySelector('#phone');
    const phoneNumber = phoneInput.value;
    const digitsOnly = phoneNumber.replace(/[^\d]/g, '');

    if (digitsOnly.length !== 12) {
      alert(window.uiText?.alerts?.invalidPhone || 'Будь ласка, введіть повний номер телефону (12 цифр)');
      phoneInput.style.border = '2px solid red';
      setTimeout(() => { phoneInput.style.border = ''; }, 3000);

      this.isSubmitting = false; 
      if (submitButton) { submitButton.disabled = false; submitButton.style.opacity = '1'; submitButton.innerText = 'Замовити'; }
      return;
    }

    // ID транзакции
    const now = new Date();
    const datePart = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')}`;
    const timePart = `${String(now.getHours()).padStart(2, '0')}-${String(now.getMinutes()).padStart(2, '0')}-${String(now.getSeconds()).padStart(2, '0')}`;
    const transactionId = `${datePart}_${timePart}`;

    // Собираем данные формы
    const formData = {
      name: form.querySelector('#name').value,
      phone: form.querySelector('#phone').value,
      email: form.querySelector('#email').value,
      message: form.querySelector('#message') ? form.querySelector('#message').value : '',
      payment_method: form.querySelector('input[name="payment_method"]:checked').value,
      delivery_method: form.querySelector('input[name="delivery_method"]:checked').value,
      transactionId: transactionId
    };

    try {
      // 1. Формируем текст сообщения для Telegram
      const orderData = this.formatOrder(cartItems, formData);

      // 2. Отправляем на сервер
      const response = await fetch('/api/submit-order', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          message: orderData.message,
          formData: formData,
          cartItems: cartItems
        })
      });

      // --- ДОБАВЛЕНА ОБРАБОТКА 429 ОШИБКИ (СПАМ-ЛИМИТ) ---
      if (response.status === 429) {
        const errorData = await response.json();
        alert(errorData.error); 
        this.isSubmitting = false; 
        if (submitButton) { submitButton.disabled = false; submitButton.style.opacity = '1'; submitButton.innerText = 'Замовити'; }
        return; 
      }

      if (!response.ok) {
        throw new Error('Ошибка ответа от сервера');
      }

      const data = await response.json();
      console.log('Відповідь сервера:', data);

      // --- АНАЛИТИКА ---
      if (typeof AnalyticsModule !== 'undefined') {
        AnalyticsModule.sendPurchaseData(
          transactionId,
          orderData.totalSum,
          cartItems,
          { email: formData.email, phone: formData.phone, name: formData.name }
        );
      }

      // --- СОХРАНЯЕМ ЧЕК ДЛЯ СТРАНИЦЫ УСПЕХА (Только если это НЕ онлайн оплата, 
      // потому что при онлайн-оплате мы передаем номер заказа через ссылку)
      if (!data.novaPayUrl) {
          const successData = {
            id: formData.transactionId,
            items: cartItems,
            total: orderData.totalSum,
            payment: formData.payment_method,
            delivery: formData.delivery_method,
            name: formData.name,
            phone: formData.phone,
            email: formData.email,
            message: formData.message
          };
          sessionStorage.setItem('lastOrder', JSON.stringify(successData));
      }

      // Очищаем корзину (заказ-то оформлен!)
      localStorage.removeItem('cart');
      if (typeof CartModule !== 'undefined') {
        CartModule.updateCartCounter();
      }

      // --- ФИНАЛЬНЫЙ РЕДИРЕКТ КЛИЕНТА ---
      if (data.success) {
        if (data.novaPayUrl) {
          // Если есть ссылка на NovaPay - перекидываем туда
          window.location.href = data.novaPayUrl;
        } else {
          // Если наложка/перевод - перекидываем на нашу родную страницу успеха
          const currentLang = document.documentElement.lang || 'uk';
          window.location.href = `/${currentLang}/success`;
        }
      }

    } catch (error) {
      console.error('Ошибка:', error);
      alert('Сталася помилка під час відправлення замовлення. Будь ласка, спробуйте пізніше або зв\'яжіться з нами по телефону.');
      this.isSubmitting = false; 
      if (submitButton) { submitButton.disabled = false; submitButton.style.opacity = '1'; submitButton.innerText = 'Замовити'; }
    }
  },

  formatOrder(cartItems, formData) {
    let message = '🛍️ Інтернет-магазин MONS.IN.UA\nДякуємо за ваше замовлення!\n\n';

    message += `🆔 ID: ${formData.transactionId}\n`;
    message += `👤 Покупець: ${formData.name}\n`;
    message += `📱 Телефон: ${formData.phone}\n`;
    message += `📧 Email: ${formData.email}\n`;

    let paymentMethodText = 'Не вказано';
    if (formData.payment_method === 'cod') {
      paymentMethodText = 'Накладений платіж';    
    } else if (formData.payment_method === 'bank_iban') {
      paymentMethodText = 'IBAN';
    } else if (formData.payment_method === 'bank_liqpay') {
      paymentMethodText = 'Онлайн оплата (NovaPay)'; // Специфика MONS
    }
    message += `💳 Оплата: ${paymentMethodText}\n`;

    let deliveryMethodText = 'Не вказано';
    if (formData.delivery_method === 'post') {
      deliveryMethodText = 'На поштове відділення';
    } else if (formData.delivery_method === 'machine') {
      deliveryMethodText = 'Поштомат';
    } else if (formData.delivery_method === 'address') {
      deliveryMethodText = 'Адресна доставка';
    } else if (formData.delivery_method === 'courier') {
      deliveryMethodText = 'Доставка кур\'єром';
    }
    message += `🚚 Доставка: ${deliveryMethodText}\n`;

    if (formData.message && formData.message.trim() !== '') {
      message += `💬 Деталі: ${formData.message.trim()}\n`;
    }

    message += '\n📦 ТОВАРИ:\n';

    let totalSum = 0;

    cartItems.forEach((item, index) => {
      message += `\n${index + 1}. ${item.title.trim()}\n`;

      // 🔥 Безопасная очистка объема
      let cleanVolume = item.volume && typeof item.volume === 'string' 
        ? item.volume.replace(/[-\s]+$/, '').trim() 
        : '';

      // 🔥 Компактная строчка характеристик
      let detailsRow = [];
      if (cleanVolume) detailsRow.push(`🔹 ${cleanVolume}`);
      if (item.sku) detailsRow.push(`🏷️ Арт: ${item.sku}`);

      if (detailsRow.length > 0) {
        message += `${detailsRow.join('  |  ')}\n`;
      }

      // 🔥 Вывод только количества и цены
      message += `— ${item.quantity} шт. x ${item.price} грн\n`;

      totalSum += item.total;
    });

    message += `\n💰 ДО СПЛАТИ: ${totalSum} грн`;

    message += `\n\n🔵 Meest або 🟢 Rozetka — доставка трохи довше але дешевше.`;

    message += `\n\n🚚 Нова Пошта - нові умови. Термін зберігання посилки 5 днів, далі повернення.`;

    message += `\n\n🛍️ Підтверджуєте замовлення?`;

    return { message, totalSum };
  }
};
// ------------END------------

// ------------AnalyticsModule - для отправки данных в GTM + Google Analytics------------
const AnalyticsModule = {

  // Отправка события ADD TO CART
  sendAddToCartData(items, totalValue) {
    if (!items || items.length === 0) return;

    // Мапим данные (на всякий случай, для надежности)
    const itemsForGA4 = items.map(item => ({
      item_id: item.item_id || item.sku,      // Берем ID или SKU
      item_name: item.item_name || item.title, // Берем Имя или Title
      price: parseFloat(item.price),
      quantity: parseInt(item.quantity, 10)
    }));

    // Очищаем ecommerce объект перед отправкой (важно для SPA и GTM)
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ ecommerce: null });

    window.dataLayer.push({
      'event': 'add_to_cart',
      'ecommerce': {
        'currency': 'UAH',
        'value': parseFloat(totalValue),
        'items': itemsForGA4
      }
    });

    console.log('Analytics: AddToCart sent', itemsForGA4);
  },

  // Отправка события PURCHASE
  sendPurchaseData(transactionId, transactionValue, cartItems, userData = {}) {
    if (!transactionId || !cartItems) {
      console.error('Analytics: Ошибка Purchase - нет ID или товаров');
      return;
    }

    const itemsForGA4 = cartItems.map(item => ({
      item_id: item.sku || item.volume,
      item_name: item.title,
      price: parseFloat(item.price),
      quantity: parseInt(item.quantity, 10)
    }));

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ ecommerce: null });

    // Формируем объект события
    const purchaseEvent = {
      'event': 'purchase',
      'ecommerce': {
        'transaction_id': transactionId,
        'value': parseFloat(transactionValue),
        'currency': 'UAH',
        'items': itemsForGA4
      }
    };

    // --- НОВОЕ: ДОБАВЛЯЕМ user_data ДЛЯ ENHANCED CONVERSIONS ---
    // Если передали userData, добавляем её в событие
    if (userData && (userData.email || userData.phone)) {
      purchaseEvent.user_data = {
        email: userData.email,         // GTM сам захеширует
        phone_number: userData.phone,  // GTM сам захеширует
        // Можно добавить имя, если хочется, но email/phone главнее
        address: {
          first_name: userData.name
        }
      };
    }

    window.dataLayer.push(purchaseEvent);

    console.log('Analytics: Purchase sent with User Data', {
      id: transactionId,
      value: parseFloat(transactionValue),
      user_data: purchaseEvent.user_data
    });
  }
};
// ------------END------------

// ------------ ФИНАЛЬНАЯ ВЕРСИЯ CartAnimationModule (Vanilla JS) ------------
const CartAnimationModule = {
  init() {
    // Используем делегирование событий: вешаем один слушатель на весь body
    document.body.addEventListener('click', (e) => {
      // Ищем, был ли клик по кнопке заказа или по ее дочерним элементам
      const targetBtn = e.target.closest('.products__card-btn--order');
      if (!targetBtn) return;

      e.preventDefault();

      // --- ПРОВЕРКА НА ПУСТУЮ КОРЗИНУ ---
      const quantityElements = document.querySelectorAll('.products__card-number');
      let totalQuantity = 0;

      quantityElements.forEach(el => {
        totalQuantity += parseInt(el.textContent) || 0;
      });

      // Если общее количество равно нулю, ничего не делаем
      if (totalQuantity === 0) return;
      // --- КОНЕЦ ПРОВЕРКИ ---

      const cart = document.querySelector('.header__cart');
      const productBox = targetBtn.closest('.product-page__wrapper');

      if (!cart || !productBox) return;

      const productImg = productBox.querySelector('.product-gallery__main img');
      if (!productImg) return;

      // 1. Создаем клон изображения
      const clone = productImg.cloneNode(true);

      // 2. Получаем точные координаты картинки относительно экрана (viewport)
      const rect = productImg.getBoundingClientRect();

      // 3. Устанавливаем начальные стили клона через Object.assign
      // Мы используем position: fixed, чтобы не возиться с прокруткой страницы (scrollTop)
      Object.assign(clone.style, {
        position: 'fixed',
        top: `${rect.top}px`,
        left: `${rect.left}px`,
        width: `${rect.width}px`,
        height: `${rect.height}px`,
        zIndex: '1000',
        transition: 'all 1.2s cubic-bezier(0.42, 0, 0.58, 1)', // Нативная плавная кривая
        pointerEvents: 'none', // Чтобы клон не "перехватывал" клики мышки
        opacity: '0.9'
      });

      clone.classList.add('product-clone');
      document.body.appendChild(clone);

      // 4. Рассчитываем координаты цели (корзины)
      const cartRect = cart.getBoundingClientRect();
      const targetTop = cartRect.top + 9;
      const targetLeft = cartRect.left + 11;

      // 5. Запускаем анимацию в следующем кадре отрисовки (аналог setTimeout 20мс)
      // requestAnimationFrame обеспечивает идеальную синхронизацию с частотой монитора
      requestAnimationFrame(() => {
        clone.classList.add('is-flying');
        Object.assign(clone.style, {
          top: `${targetTop}px`,
          left: `${targetLeft}px`,
          width: '25px',
          height: '25px',
          opacity: '0.3' // Клон немного тускнеет при подлете
        });
      });

      // 6. Удаляем клон после завершения CSS-перехода
      clone.addEventListener('transitionend', () => {
        clone.remove();
        // Вызываем сброс счетчиков после анимации
        if (typeof CartModule !== 'undefined' && CartModule.resetProductCounters) {
          CartModule.resetProductCounters();
        }
      }, { once: true }); // Слушатель удалится сам после выполнения
    });
  }
};
// ------------ END ------------

// ------------ CopyModule (Копирование реквизитов IBAN) ------------
const CopyModule = {
  init() {
    const copyButtons = document.querySelectorAll('.checkout__copy-btn');

    copyButtons.forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.preventDefault(); // На всякий случай блокируем стандартное поведение

        const targetId = btn.getAttribute('data-copy-target');
        const textElement = document.getElementById(targetId);

        if (textElement) {
          // Берем чистый текст без пробелов по краям
          const textToCopy = textElement.textContent.trim();

          // Современный метод копирования в буфер обмена
          navigator.clipboard.writeText(textToCopy).then(() => {
            // Визуальный отклик: меняем иконку на галочку
            const originalHTML = btn.innerHTML;
            btn.classList.add('success');
            btn.innerHTML = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg>';

            // Возвращаем исходную иконку через 2 секунды
            setTimeout(() => {
              btn.classList.remove('success');
              btn.innerHTML = originalHTML;
            }, 2000);
          }).catch(err => {
            console.error('Ошибка копирования: ', err);
            alert('Не вдалося скопіювати текст. Спробуйте вручну.');
          });
        }
      });
    });
  }
};
// ------------ END ------------

// --- ОТПРАВКА ОТЗЫВА ---
const ReviewModule = {
  init() {
    this.form = document.getElementById('add-review-form');
    this.messageBox = document.getElementById('review-message');
    this.submitBtn = document.getElementById('submit-review-btn');

    if (this.form) {
      // Биндим контекст this, чтобы внутри handleSubmit иметь доступ к свойствам модуля
      this.form.addEventListener('submit', this.handleSubmit.bind(this));
    }
  },

  async handleSubmit(e) {
    e.preventDefault();

    // 1. Запоминаем оригинальный текст кнопки (на текущем языке)
    const originalBtnText = this.submitBtn.innerText;

    // Замок от двойного клика
    this.submitBtn.disabled = true;
    this.submitBtn.innerText = '...';

    // Собираем данные
    const productSlug = document.getElementById('review-product-slug').value;
    const authorName = document.getElementById('review-author').value;
    const rating = document.getElementById('review-rating').value;
    const reviewText = document.getElementById('review-text').value;

    try {
      const response = await fetch('/api/add-review', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ productSlug, authorName, rating, reviewText })
      });

      // Защита от спама (Rate Limiting)
      if (response.status === 429) {
        const errorData = await response.json();
        throw new Error(errorData.error);
      }

      const result = await response.json();

      if (result.success) {
        this.form.reset();
        // Успех
        this.form.style.display = 'none';
        this.messageBox.style.display = 'block';
        this.messageBox.style.color = '#22C55E';
        this.messageBox.innerText = result.message;
      } else {
        // Ошибка валидации сервера
        throw new Error(result.error);
      }
    } catch (error) {
      // Ошибка (показываем красным)
      this.messageBox.style.display = 'block';
      this.messageBox.style.color = '#EF4444';
      this.messageBox.innerText = error.message;

      // Снимаем замок и возвращаем родной текст
      this.submitBtn.disabled = false;
      this.submitBtn.innerText = originalBtnText;
    }
  }
};


// ------------Функция инициализации всех модулей------------
function initializeApp() {

  // ActiveMenuModule.init(); 
  BurgerMenuModule.init();
  SliderModule.init();
  ProductModule.init();
  FormModule.init();
  PhoneModule.init();
  CartAnimationModule.init();
  CartModule.init();
  CopyModule.init();
  ReviewModule.init();
}

// Запускаем всю цепочку, когда DOM полностью готов
document.addEventListener('DOMContentLoaded', initializeApp);